import React from "react";

type SaraVariant = {
    name: string;
    image: string;
};

type SpecRow = {
    label: string;
    values: [string, string];
};

const variants: SaraVariant[] = [
    { name: "SARA Nano", image: "/products/Sara/SARA Nano.png" },
    { name: "SARA Pro", image: "/products/Sara/SARA Pro.png" },
];

const specRows: SpecRow[] = [
    { label: "Platform Type", values: ["Cubesats up to 16U", "Microsats"] },
    { label: "Orbit", values: ["LEO missions", "LEO & GEO missions"] },
    { label: "Power Transfer", values: ["330W @37V", "550W @37V"] },
    { label: "Maximum\nSolar Wing Mass", values: ["2.5kg", "10kg"] },
];

const SaraPowerTable: React.FC = () => {
    return (
        <div
            data-aos="fade-zoom-in"
            data-aos-offset="200px"
            data-aos-delay="300"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
            className="with-border relative group p-10 transition-all duration-200 overflow-hidden"
        >
            <div className="absolute inset-0 transform -scale-x-3 -scale-y-3 group-hover:scale-100 transition-transform duration-200"></div>

            <div className="relative z-10 text-white">
                {/* ── Product renders + titles ── */}
                <div className="grid grid-cols-3">
                    <div></div>
                    {variants.map((v) => (
                        <div key={v.name} className="flex flex-col items-center text-center">
                            <img
                                src={v.image}
                                alt={v.name}
                                className="h-32 sm:h-44 md:h-52 w-auto object-contain"
                            />
                            <span className="uppercase font-bold tracking-wider text-sm md:text-base mt-4">
                    {v.name}
                  </span>
                        </div>
                    ))}
                </div>

                {/* ── Spec rows: label + two values, divided by thin lines ── */}
                <div className="mt-8">
                    {specRows.map((row) => (
                        <div
                            key={row.label}
                            className="grid grid-cols-3 border-t border-white/50 py-5 md:py-6"
                        >
                            <div className="uppercase font-bold tracking-wider text-xs sm:text-sm pr-2 whitespace-pre-line">
                                {row.label}
                            </div>
                            {row.values.map((value, i) => (
                                <div
                                    key={i}
                                    className="uppercase tracking-wide text-xs sm:text-sm md:text-base pl-1 sm:pl-2"
                                >
                                    {value}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SaraPowerTable;
